<template>
  <div>
    <v-alert dense border="bottom" type="primary" icon="mdi-information">CUSTOMER INFORMATION</v-alert>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field
              v-model="information.customer_name"
              label="Name"
              :rules="[v => !!v || 'Customer Name is required']"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="3" md="3">
            <v-text-field
              v-model="information.customer_tel"
              label="Telephone"
              :rules="[v => !!v || 'Customer Tel is required']"
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="3" md="3">
            <v-text-field v-model="information.customer_email" label="Email"></v-text-field>
            <!-- :rules="[v => !!v || 'E-mail is required',v => /.+@.+/.test(v) || 'E-mail must be valid']" -->
            <!-- <v-text-field v-else v-model="information.customer_email" label="Email"></v-text-field> -->
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </div>
</template>
<script>
import axios from "axios";

export default {
  props: ["information", "condition"],
  data() {
    return {
    };
  },
};
</script>
